// import { AudioPlayer } from "../../reporting/audio_player";

export class SevenDayCallCountModal extends HTMLElement {
  constructor(campaign_id) {
    super();
    this.campaign_id = campaign_id
  }
  connectedCallback() {
    this.innerHTML =
      `
      <style>
        #sevenDayCallCountModal .modal-dialog {
          height: 900px;
        }
        
        #sevenDayCallCountModal tbody td {
          height: 32px;
        }
      </style>
      <div class="modal fade bd-example-modal-sm" id="sevenDayCallCountModal" data-cy="seven-day-call-count" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Campaign Recent Calls</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <table class="table recent_calls_table" style="width:100%">
                <thead>
                  <th>Audio</th>
                  <th>Time of Call</th>
                  <th>Caller ID</th>
                </thead>
                <tbody>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      `;

    this.init();

    this.querySelector('.close').addEventListener('click', function() {
      this.hide();
    }.bind(this))
  }

  async init() {
    this.table = $(this.querySelector('.recent_calls_table')).DataTable({
      "ajax": `/admin/campaigns/${this.campaign_id}/recent_calls`,
      "columns": [
        {
          data: "audiourl", "className": 'text-center',
          "render": function ( data, type, row ) {
            return data != null ? `<audio-player src=${data}></audio-player>` : ''
          },
        },
        {
          data: "call_start_time", "className": 'text-center',
          "render": function ( data, type, row ) {
            return moment(data).format("MMMM DD, YYYY h:mm A")
          },
        },
        {
          data: "ani", "className": 'text-center',
          "render": function ( data, type, row ) {
            return data != null ? data.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : "";
          },
        }
      ],
      order: [[ 1, "desc" ]]
    });
  }

  show() {
    $("#sevenDayCallCountModal").modal('show');
  }

  hide() {
    this.remove();
  }
}

customElements.define('seven-day-call-count-modal', SevenDayCallCountModal)